import * as React from "react";
import type { SVGProps } from "react";
export const SvgYearInReviewQuadra = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#year-in-review-quadra_svg__a)">
      <path fill="currentColor" d="M12 2.547 21.452 12 12 21.452 2.548 12 12 2.547Z" />
    </g>
    <defs>
      <clipPath id="year-in-review-quadra_svg__a">
        <path fill="#fff" d="M2.4 2.4h19.2v19.2H2.4z" />
      </clipPath>
    </defs>
  </svg>
);
